import EditCompany from './EditCompany';
export default EditCompany;
